import { changeDateRange } from './state/change-date-range.epic';
import { reload } from './state/reload.epic';

export const landingEpics = [reload, changeDateRange];
